import './style.scss';

const Loading = ({ type = 'grid', color = '#1e81d8' }) => {
    return (
        <>
            {type === 'grid' && (
                <div style={{ '--color': color }} className='lds-grid'>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            )}
            {type === 'ellipsis' && (
                <div style={{ '--color': color }} className='lds-ellipsis'>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            )}
        </>
    );
};

export default Loading;
